// extracted by mini-css-extract-plugin
module.exports = {"dropdown-background":"DDLLoader-module__dropdown-background__3q8Ru"};